import { render, staticRenderFns } from "./RestorePassword.vue?vue&type=template&id=3b7dbc2e&scoped=true&"
import script from "./RestorePassword.vue?vue&type=script&lang=js&"
export * from "./RestorePassword.vue?vue&type=script&lang=js&"
import style0 from "./RestorePassword.vue?vue&type=style&index=0&id=3b7dbc2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7dbc2e",
  null
  
)

export default component.exports